import './Homepage.css'
import { AiOutlineTeam, AiOutlineSafety  } from "react-icons/ai";
import { PiHandshake } from "react-icons/pi";
import { ButtonPrimary, SectionHeader, SectionWrap, ButtonSecoundry, FAQ, Post, WhyUsAcc, FloatingLines, ContactSection } from '../../Components/index';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react'
import {OurWork, Subscribe} from '../../sections/index';
import custum1 from '../../assest/images/custum1.png';
import custum2 from '../../assest/images/custum2.png';
import custum3 from '../../assest/images/custum3.jpg';
import custum4 from '../../assest/images/custum4.jpg';
import custum5 from '../../assest/images/custum5.png';
import custum6 from '../../assest/images/custum6.png';
import { FaApple } from "react-icons/fa";
import { RiGooglePlayFill } from "react-icons/ri";
import lawnexLogo from '../../assest/images/lawnexLogo.svg';
import { Link } from 'react-router-dom';






import AOS from 'aos'
import 'aos/dist/aos.css'
AOS.init();

function Homepage() {
  const { t, i18n } = useTranslation();
  const [posts, setPosts] = useState([]);
  const apiUrl = 'https://www.albarede.com/server';
  
 useEffect(() => {
  fetch(`${apiUrl}/post.php`, { // سيقوم هذا الطلب الآن بجلب جميع المنشورات من الخادم
    method: 'GET',
    mode: 'cors'
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(allPosts => { // سميناها allPosts لتوضيح أنها جميع المنشورات
      // فرز المنشورات (إذا لم يكن الخادم يفرزها بشكل موثوق) ثم أخذ أول3 
      const latestSixPosts = allPosts
        .sort((a, b) => new Date(b.createAt) - new Date(a.createAt)) // تأكد من الفرز تنازليًا
        .slice(0, 3); // هنا يتم أخذ آخر 3 منشورات فقط

      setPosts(latestSixPosts); // قم بتعيين الستة الأحدث فقط إلى حالة posts
    })
    .catch(error => {
      console.error('Error fetching posts:', error);
    });
}, []);
  
  const myBrandGradient = [
  "#0a2b4f", 
  "#041630", 
  "#d4af7a"  
  ];
  const logos = [custum1, custum2, custum3, custum4, custum5, custum6];

  return (
    <>
    {/* start homepage */}
      <div id='home-page' className='hompage-background'>
          <div className='hero-canvas-wrapper' >
          <FloatingLines 
              enabledWaves={['top', 'middle', 'bottom']}
              lineCount={7}
              lineDistance={52}
              bendRadius={21.5}
              bendStrength={-3.5}
              interactive
              parallax={true}
              animationSpeed={1.8}
              linesGradient={myBrandGradient}
          />
          <div className="hero-shader-mask"></div>
        </div>
          <div className='homeItems'>
              <div className='home-company'>
                <p className='slogen'>{t("slogan")}</p>
                <h1>{t('company-name')}<em>{t('company-disc')}</em></h1>
                <p className='disc'>{t('homeDisc')}</p>
                <div className='buttons'>
                  <ButtonSecoundry hide='' href='/CaseQuery'>
                    {t('CaseInqu')}
                  </ButtonSecoundry>
                  <ButtonPrimary hide='/appointments' href='/appointments'>
                    {t('book_appoin')}
                  </ButtonPrimary>
                </div>
              </div>
                  <div className="lawnex-card">
                    <div className="lawnex-shine"></div>
                    <div className="lawnex-inner">
                    <div className="lawnex-logo">
                      <img src={lawnexLogo} className="lawnex-icon" alt='logoLawnex'/>
                      <div>
                      <div className="lawnex-name">LAWNEX</div>
                      <div className="lawnex-tagline">{t('LawnexSlogan')}</div>
                    </div>
                  <p className="lawnex-desc">{t('LawnexDisc')}</p>
                  <div className='DownloadsBtn'>
                   <a className='DownBtn' href='https://play.google.com/store/apps/details?id=com.lawnex.app&pcampaignid=web_share' title='google play'>
                      <RiGooglePlayFill/>
                      <div>
                        <span>GET IN ON</span>
                        <p>Google Play</p>
                      </div>
                   </a>
                   <a className='DownBtn' href='https://apps.apple.com/us/app/lawnex/id6771798710' title='google play'>
                      <FaApple/>
                      <div>
                        <span>Download on the</span>
                        <p>App Store</p>
                      </div>
                   </a>
                  </div>
                </div>
                </div>
              </div>
          </div>
          </div>
      
    {/* End homepage */}
<div className='cuntenuiBack'>
<div className='sectionShort'>
              <div className='shortItems' data-aos='fade-up'>
                <span>01-تطبيقنا</span>
              <h2>{t('Lawnex')}</h2>
                <p>{t('Lawnex_disc')}</p>
                <a href="/lawnex">
                ←
                </a>
              </div>
              <div className='shortItems' data-aos='fade-up'>
                <span>02-مقالاتنا</span>
                <h2>{t('ourArticles')}</h2>
                <p>{t('articlesDisc')}</p>
                <a href='/articles'>
                  ←
                </a>
              </div>
              <div className='shortItems' data-aos='fade-up'>
                <span>03-قوانين</span>
                <h2>{t('rules')}</h2>
                  <p>{t('rulsShortDisc')}</p>
                  <a href='/laws'>
                  ←
              </a>
          </div>
  </div>
  </div>


  {/* start about us */}
  <div className='containerNew' data-aos='fade-up'>
    <div id='about-us' className='about-us'>
      <SectionHeader title={t('summray')} disc={t('summraySlogen')}/>
        <div className='about-info' data-aos='fade-up'>
            <div className='about-item'>
              <span>{t('welcomTo')} </span>
              <p>{t('summary-disc')}</p>
              <p>{t('lawnex-launch')}</p>
              <div className='aboutBtn'>
              <ButtonSecoundry href='#contactUsSec'>{t('contactUsBtn')}</ButtonSecoundry>
              <ButtonPrimary href='/lawnex'>{t('Lawnex')}</ButtonPrimary>
              </div>
            {/* <WhyUsAcc /> */}
            </div>
        <div className='why-us2-disc'>
          <div className='disc-item' data-aos='fade-up'>
            <div className='item-svg'>
            <AiOutlineTeam />
            </div>
            <div>
              <h3>{t('whyUs2H31')}</h3>
              <p>{t('whyUs2P1')}</p>
            </div>
          </div>
          <div className='disc-item' data-aos='fade-up'>
            <div className='item-svg'>
            <PiHandshake />
            </div>
            <div>
              <h3>{t('whyUs2H32')}</h3>
              <p>{t('whyUs2P2')}</p>
            </div>
          </div>
          <div className='disc-item' data-aos='fade-up'>
            <div className='item-svg'>
            <AiOutlineSafety />
            </div>
            <div>
              <h3>{t('whyUs2H33')}</h3>
              <p>{t('whyUs2P3')}</p>
            </div>
          </div>
        </div>
        </div>
    </div>
  </div>
    {/* End about us */}
    <OurWork/>
    {/* start our fields */} 
    <div className='ourFieldsHome containerNew' data-aos='fade-up'>
      <SectionWrap>
        <SectionHeader title={t('fieldsTitle')} disc={t('teamTitleDisc')} />
        <div className='fielsContainer'>
            <div className='fieldsItem' data-aos='fade-up'>
                <span>01</span>
                <h4>{t('fieldsShort1')}</h4>
                <p>{t('fieldsShortDisc1')}</p>
                <Link to={'/firms'} target='_top'>{t('readMore')}</Link>
            </div>
            <div className='fieldsItem' data-aos='fade-up'>
                <span>02</span>
                <h4>{t('fieldsShort2')}</h4>
                <p>{t('fieldsShortDisc2')}</p>
                <Link to={'/property'} target='_top'>{t('readMore')}</Link>
            </div>
            <div className='fieldsItem' data-aos='fade-up'>
                <span>03</span>
                <h4>{t('fieldsShort3')}</h4>
                <p>{t('fieldsShortDisc3')}</p>
                <Link to={'/conflict'} target='_top'>{t('readMore')}</Link>
            </div>
        </div>
        <div className='fieldInfoHome'>
        <ButtonPrimary href='/fields'>{t('vew_all')}</ButtonPrimary>
        </div>
      </SectionWrap>
    </div>
    {/* End our fields */}
    
    {/* start subs section */}
    <Subscribe />
    {/* end subs section */}
   
    {/*  start articls */}
      <div className='containerNew' data-aos='fade-up'>
        <SectionWrap>
          <SectionHeader title={t('latestArticles')} disc={t('variesArticles')}/>
        <div className='postsContainer'>
        {posts.length > 0 && posts.map(post => (
        <Post key={post.id} id={post.id}  title={post.title} files={post.files} summary={post.summary} author={post.author} createAt={post.createAt}/>
      ))}
      </div>
      <div className='moreArticlsBtn'>
        <ButtonPrimary href='/articles'>{t('readMoreArticlesBtn')}</ButtonPrimary>
        </div>
      </SectionWrap>
      </div>
    {/*  End articls */}
    <div id='contactUsSec'><ContactSection /></div>
    {/* start why us2 section */}

    {/* start our services sectio */}
    <div id='our-serv' className='our-services containerNew' data-aos='fade-up'>
      <SectionWrap>
        <SectionHeader title={t('ourServisesTitle')} disc={t('ourServicesDisc')}/>
        <div className="services-grid">
          <div className="service-card"><div className="service-icon">⚖</div><h3>{t('Litigation_Representation')}</h3><p>{t('Litigation_RepresentationDisc')}</p></div>
          <div className="service-card"><div className="service-icon">📋</div><h3>{t('Contract_Drafting')}</h3><p>{t('Contract_DraftingDisc')}</p></div>
          <div className="service-card"><div className="service-icon">🏛</div><h3>{t('Company_Formation')}</h3><p>{t('Company_FormationDisc')}</p></div>
          <div className="service-card"><div className="service-icon">💼</div><h3>{t('Legal_Consultations')}</h3><p>{t('Legal_ConsultationsDisc')}</p></div>
        </div>
      </SectionWrap>
    </div>
    {/* end our services sectio */}
   

{/* start custmer section */}
<div className='containerNew'>
      <SectionWrap>
        <SectionHeader title={t('clientsTitle')} disc={t('clientDisc')} />
        
        {/* الحاوية الكبرى التي تقص الأطراف الزائدة (Overflow Hidden) */}
        <div className='logo-loop-slider'>
          
          {/* الحاوية المتحركة التي تحتوي على المجموعتين */}
          <div className='custimerLogo-track'>
            
            {/* المجموعة الأولى الأصلية */}
            <div className='logos-group'>
              {logos.map((logo, index) => (
                <img key={`orig-${index}`} src={logo} alt='logo company' />
              ))}
            </div>

            {/* المجموعة الثانية المضاعفة (تضمن استمرار الحلقة بصرياً) */}
            <div className='logos-group' aria-hidden="true">
              {logos.map((logo, index) => (
                <img key={`dup-${index}`} src={logo} alt='logo company' />
              ))}
            </div>

          </div>
          
        </div>
      </SectionWrap>
    </div>
    {/* end custmer section */}
    </>
  )
}

export default Homepage;